import React, { useContext } from 'react';
import classnames from 'classnames';
import { AccordionContext, AccordionGroupContext } from '../../context';
import { APPEARANCES } from '../../constants';

const AccordionContent = ({ children }) => {
  const { activeItems, appearance } = useContext(AccordionContext);
  const itemId = useContext(AccordionGroupContext);

  const isActive = activeItems.includes(itemId);
  const isBorderedAppearance = appearance === APPEARANCES.bordered;

  const classes = classnames('ws-ui-accordion-content', {
    'ws-ui-accordion-content--bordered': isBorderedAppearance,
  });

  return isActive ? <div className={classes}>{children}</div> : null;
};

export default AccordionContent;
